export default __webpack_public_path__ + "static/media/l_quote.c55be9b5.svg";